import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import { TRoleListing } from '~types/feat/admin';

import Table from '~components/molecules/Table';
import ActionButton from '~components/atoms/ActionButton';

import UtilFunctions from '~utils/functions';
import { ModuleEnum, PermissionsEnum, RoleStatusEnum } from '~utils/enums';

import * as Styles from './_rolesTable.module.scss';

const RolesTable = () => {
    const { Misc: { dateTimeFormat } } = UtilFunctions;

    const dispatch = useAppDispatch();

    const index = useAppSelector(state => state.admin.roleListing.index);
    const roleListing = useAppSelector(state => state.admin.roleListing.data);
    const isLoading = useAppSelector(state => state.admin.loadings.getRoleListing);
    const access = useAppSelector(state => state.auth.userDetails.access);

    const hasEditAccess = access.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.RBAC);

    const setRoleDetails = (role: TRoleListing) => dispatch(combinedActions.adminSetRoleDetails(role));

    useEffect(() => {
        dispatch(combinedActions.adminGetRoleListingAttempt());
    }, [index]);

    const handleViewRoleDetailsClick = (role: TRoleListing) => {
        dispatch(combinedActions.adminSetRoleDetailsModalIsOpen(true));
        dispatch(combinedActions.adminSetRoleDetailsModalIsEditing(false));
        setRoleDetails(role);
    };

    const handleEditRoleClick = (role: TRoleListing) => {
        dispatch(combinedActions.adminSetRoleDetailsModalIsOpen(true));
        dispatch(combinedActions.adminSetRoleDetailsModalIsEditing(true));
        setRoleDetails(role);
    };

    const handleDeleteRoleClick = (role: TRoleListing) => {
        dispatch(combinedActions.adminSetDeleteRoleModalIsOpen(true));
        dispatch(combinedActions.adminSetRoleDetailsModalIsEditing(false));
        setRoleDetails(role);
    };

    const header = [
        'ROLE ID',
        'ROLE NAME',
        'STATUS',
        'CREATED AT',
        'UPDATED AT',
        'ACTION',
    ];

    const body = roleListing.map(role => {
        const {
            roleId,
            roleName,
            status,
            createdAt,
            updatedAt,
        } = role;

        return [
            roleId,
            roleName,
            RoleStatusEnum[status],
            dateTimeFormat(createdAt),
            dateTimeFormat(updatedAt),
            (
                <div
                    key={roleId}
                    className={Styles['button-container']}
                >
                    <div>

                        <ActionButton
                            label='View'
                            onClick={() => handleViewRoleDetailsClick(role)}
                        />

                        <>
                            {hasEditAccess
                            && (
                                <ActionButton
                                    label='Edit'
                                    onClick={() => handleEditRoleClick(role)}
                                />
                            )
                            }

                            {hasEditAccess && status !== RoleStatusEnum.Deactivated
                            && (
                                <ActionButton
                                    label='Delete'
                                    onClick={() => handleDeleteRoleClick(role)}
                                    className={Styles.danger}
                                />
                            )
                            }
                        </>
                    </div>
                </div>
            ),
        ];
    });

    return (
        <Table
            header={header}
            body={body}
            isLoading={isLoading}
        />
    );
};

export default RolesTable;
